export * from './env.constants';
export * from './base-url.constants';
export * from './api.constants';
export * from './currency.constants';
export * from './payment-type.constant';
export * from './star-rating.constants';
export * from './provinces';
export * from './bkk.zipcode.constants';
export * from './k-bank.constant';
export * from './thai-address';
export * from './wording';
export * from './2c2p.constant';

export const SHIPPING_SELECT = {
    POST_OFFICE: "postOffice",
    BRANCH: "branch"
}

export const TYPE_PRODUCT = {
    VOUCHER: {
        EN: "EVENTS",
        TH: "ทุกงานแสดง"
    }
}

export const TYPE_PROMOTION = {
    PercentDiscount:        "PercentDiscount",          // Discount xx%
    SpecialPrice:           "SpecialPrice",             // Special Price
    Price_Off:              "Price_Off",                // Price Off
    buyX_getX:              "buyX_getX",                // buy x get x
    BuyUpTo_getRedeemtion:  "BuyUpTo_getRedeemtion",    // ซื้อครบ xxx บาท แลกซื้อ xxx ราคา xxx บาท
    BuyUpTo_GetItemFree:    "BuyUpTo_GetItemFree",      // ซื้อครบ xxx บาท รับฟรี xxx
    SecondItem_GetProPrice: "SecondItem_GetProPrice",   // ซื้อชิ้นที่ 1 ชิ้นที่ 2 ลดราคา xxx 
    BuyUpTo_GetVoucherFree: "BuyUpTo_GetVoucherFree",   // ซื้อครบ xxx บาท รับฟรี VOUCHER
    Buy2piece_GetDiscount:  "Buy2piece_GetDiscount"     // ซื้อชิ้นที่ 2 ชิ้น รับส่วนลด
}

export const TYPE_USAGE = {
    Direct: "Direct",
    ONTOP:  "ONTOP",
    COUPON: "COUPON"
}